<template>
    <div class="green-toggle custom-control custom-switch">
        <input
            type="checkbox"
            class="custom-control-input"
            :id="id"
            :value="value"
            :checked="value"
            :disabled="disabled"
            @change="onChange"
        />
        <label class="custom-control-label" :for="id">
            {{ label }}
        </label>
        <div>{{ description }}</div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ""
        },
        description: {
            type: String,
            default: ""
        },
        id: {
            type: String,
            default: ""
        }
    },
    methods: {
        onChange() {
            let val = this.value ? true : false;
            this.$emit("input", !val);
            this.$emit("change", !val);
        }
    }
};
</script>
